<template>
    <div class="relative bg-gray-800">
        <div class="relative">
            <Header />
            <main class="mt-16 sm:mt-24">
                <slot></slot>
            </main>
        </div>
    </div>
    <Notification v-if="flashMessage && flashTitle" :title="flashTitle" :message="flashMessage"></Notification>
    <footer class="bg-gray-900" aria-labelledby="footer-heading">
        <h2 id="footer-heading" class="sr-only">Footer</h2>
        <div class="mx-auto max-w-md py-12 px-4 sm:max-w-lg sm:px-6 sm:pt-16 lg:max-w-7xl lg:px-8 lg:pt-24 lg:pb-16">
            <div class="xl:grid xl:grid-cols-3 xl:gap-8">
                <div class="space-y-8 xl:col-span-1">
                    <img class="h-10" src="/img/web3register-logo.png" alt="web3register.org" />
                    <p class="text-base text-gray-400">{{ translate('global.footer')('claim') }}</p>
                    <div class="flex space-x-6">
                        <a v-for="item in footerNavigation.social" :key="item.name" :href="item.href" class="text-gray-400 hover:text-gray-300">
                            <span class="sr-only">{{ item.name }}</span>
                            <component :is="item.icon" class="h-6 w-6 text-white" aria-hidden="true" />
                        </a>
                    </div>
                </div>
                <div class="mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
                    <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div></div>
                        <div></div>
                    </div>
                    <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div>
                            <h3 class="text-base font-medium text-gray-200">{{translate('global.menu')('types')}}</h3>
                            <ul role="list" class="mt-4 space-y-4">
                                <li v-for="item in footerNavigation.types" :key="item.name">
                                    <a :href="item.href" class="text-base text-gray-400 hover:text-gray-300">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-12 md:mt-0">
                            <h3 class="text-base font-medium text-gray-200">Legal</h3>
                            <ul role="list" class="mt-4 space-y-4">
                                <li v-for="item in footerNavigation.legal" :key="item.name">
                                    <a :href="item.href" class="text-base text-gray-400 hover:text-gray-300">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-12 border-t border-gray-700 pt-8">
                <p class="text-base text-gray-400 xl:text-center">&copy; 2022 web3register.org</p>
            </div>
        </div>
    </footer>
    <CookieBanner></CookieBanner>
    <!--Notification id="" title="AAAA" message="BBBBBB" /-->
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {
    UserIcon,
} from '@heroicons/vue/24/outline'
import {defineComponent, h, ref} from 'vue'
import { ChevronRightIcon, LanguageIcon } from '@heroicons/vue/20/solid'
import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import CookieBanner from "../Components/CookieBanner";
import translate from "../../lang";
import { Inertia } from '@inertiajs/inertia';
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import Header from './Header';
import Notification from "../Components/Notification";

export default {
    components: {
        Notification,
        Link,
        Header,
        UserIcon,
        CookieBanner,
        Popover,
        PopoverButton,
        PopoverPanel,
        ChevronRightIcon,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        Bars3Icon,
        BellIcon,
        XMarkIcon,
        LanguageIcon
    },
    setup() {
        let user = computed(() => usePage().props.value.auth.user);
        let flashTitle = computed(() => usePage().props.value.flash ? usePage().props.value.flash.title : null);
        let flashMessage = computed(() => usePage().props.value.flash ? usePage().props.value.flash.message : null);
        let footerMenuTypes = computed(() => usePage().props.value.footerMenuTypes);

        const footerNavigation = {
            types: [...footerMenuTypes.value],
            support: [
                { name: 'Pricing', href: '#' },
                { name: 'Documentation', href: '#' },
                { name: 'Guides', href: '#' },
                { name: 'API Status', href: '#' },
            ],
            company: [
                { name: 'About', href: '#' },
                { name: 'Blog', href: '#' },
                { name: 'Jobs', href: '#' },
                { name: 'Press', href: '#' },
                { name: 'Partners', href: '#' },
            ],
            legal: [
                { name: translate('global.menu')('terms'), href: route('terms_localized') },
                { name: translate('global.menu')('privacy'), href: route('privacy_localized') },
                { name: translate('global.menu')('imprint'), href: route('imprint_localized') },
            ],
            social: [
                {
                    name: 'Facebook',
                    href: 'https://www.facebook.com/web3register',
                    icon: defineComponent({
                        render: () =>
                            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                                h('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z',
                                    'clip-rule': 'evenodd',
                                }),
                            ]),
                    }),
                },
                {
                    name: 'Instagram',
                    href: 'https://www.instagram.com/web3register/',
                    icon: defineComponent({
                        render: () =>
                            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                                h('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
                                    'clip-rule': 'evenodd',
                                }),
                            ]),
                    }),
                },
                {
                    name: 'Twitter',
                    href: 'https://twitter.com/w3register',
                    icon: defineComponent({
                        render: () =>
                            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                                h('path', {
                                    d: 'M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84',
                                }),
                            ]),
                    }),
                },
                {
                    name: 'LinkedIn',
                    href: 'https://www.linkedin.com/company/web3register',
                    icon: defineComponent({
                        render: () =>
                            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                                h('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
                                    'clip-rule': 'evenodd',
                                }),
                            ]),
                    }),
                }
            ],
        }
        const navigation = [
            { name: 'Web 3.0 Register', href: '/' },
        ]

        function handleGoogleOneTapCredentialResponse(response) {
            axios.post(route('auth_one_tap_localized', {credential: response.credential}))
                .then((response) => {
                    gtagAds('event', 'conversion', {'send_to': 'AW-10863969210/LjkyCM-d17EDELqHrLwo'});
                    Inertia.reload();
                }, (error) => {
                    console.log(error);
                });
        }

        let instance = this;
        window.onload = function () {
            if(!usePage().props.value.auth.user) {
                google.accounts.id.initialize({
                    client_id: usePage().props.value.googleClientId, // Replace with your Google Client ID
                    callback: handleGoogleOneTapCredentialResponse.bind(instance) // We choose to handle the callback in client side, so we include a reference to a function that will handle the response
                });
                // You can skip the next instruction if you don't want to show the "Sign-in" button
                google.accounts.id.renderButton(
                    document.getElementById("buttonDiv"), // Ensure the element exist and it is a div to display correcctly
                    {theme: "outline", size: "large"}  // Customization attributes
                );
                google.accounts.id.prompt(); // Display the One Tap dialog
            }
        }

        function logout() {
            axios.post(route('auth_logout_localized')).then(function() {
                window.location.href = route('home');
            });
        }

        return {
            navigation,
            footerNavigation,
            user,
            logout,
            flashTitle,
            flashMessage,
            translate
        }
    },
}
</script>
